import './App.css';
import { useState, useEffect } from 'react';

const heroSlideshowImages = [
  '/product-photos/RCC/rcc%20door%20frame2.jpg',
  '/product-photos/RCC/rcc%20park%20bench.jpg',
  '/product-photos/RCC/rcc%20boundary%20wALL.jpg',
  '/product-photos/WPC/wpc_door_1.JPG',
  '/product-photos/WPC/WPC%20winDOW%20frame2.jpg',
  '/product-photos/WPC/window_panels.jpg'
].map(src => (process.env.PUBLIC_URL || '') + src);

function App() {
  const [activeProduct, setActiveProduct] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [cardSlideIndex, setCardSlideIndex] = useState({});
  const [zoomLightbox, setZoomLightbox] = useState(null); // { images: [], currentIndex: 0 }
  const [heroSlide, setHeroSlide] = useState(0);
  const [showBackToTop, setShowBackToTop] = useState(false);
  useEffect(() => {
    const t = setInterval(() => setHeroSlide(s => (s + 1) % heroSlideshowImages.length), 4000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const onScroll = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const categories = [
    {
      name: 'RCC Products',
      desc: 'Precast cement concrete products - durable, waterproof & eco-friendly',
      icon: '🏗️',
      color: 'linear-gradient(135deg, #FF6B35 0%, #FF8C42 100%)'
    },
    {
      name: 'WPC Products',
      desc: 'Wood Plastic Composite - sustainable alternative combining wood & plastic',
      icon: '🌳',
      color: 'linear-gradient(135deg, #FFA726 0%, #FFB74D 100%)'
    }
  ];

  const productPhoto = (folder, filename) =>
    `${process.env.PUBLIC_URL || ''}/product-photos/${folder}/${encodeURIComponent(filename)}`;

  const products = {
    'RCC Products': [
      { 
        name: 'RCC Door Frames', 
        desc: 'Precast cement concrete door frames - waterproof, termite-proof, and eco-friendly alternative to wood', 
        icon: '🚪',
        images: [productPhoto('RCC', 'rcc door frame1.jpg'), productPhoto('RCC', 'rcc door frame2.jpg')]
      },
      { 
        name: 'RCC Window Frames', 
        desc: 'Durable concrete window frames with superior quality and smooth finish', 
        icon: '🪟',
        images: [productPhoto('RCC', 'rcc window frame.jpg')]
      },
      { 
        name: 'RCC Park Benches', 
        desc: 'Precast cement benches, desk benches and park furniture - durable and weather resistant', 
        icon: '🪑',
        images: [productPhoto('RCC', 'rcc park bench.jpg'), productPhoto('RCC', 'rcc_bench.JPG')]
      },
      { 
        name: 'Cement Bed', 
        desc: 'Strong and economical precast cement bed for residential use', 
        icon: '🛏️',
        images: [productPhoto('RCC', 'cement_bed.JPG')]
      },
      { 
        name: 'RCC Boundary Wall', 
        desc: 'Precast boundary wall for secure perimeter solutions', 
        icon: '🧱',
        images: [productPhoto('RCC', 'rcc boundary wALL.jpg')]
      },
      { 
        name: 'RCC Boundary Poles', 
        desc: 'Precast cement concrete boundary poles for fencing and perimeter support', 
        icon: '📌',
        images: [productPhoto('RCC', 'rcc_boundary_pole_new.jpg'), productPhoto('RCC', 'rcc boundry pole1.jpg'), productPhoto('RCC', 'rcc boundary pole2.jpg')]
      }
    ],
    'WPC Products': [
      { 
        name: 'WPC Door Panels', 
        desc: 'Wood Plastic Composite door panels - revolutionary eco-friendly material', 
        icon: '🚪',
        images: [productPhoto('WPC', 'wpc_door_2.JPG'),productPhoto('WPC', 'wpc_door_1.JPG'),productPhoto('WPC', 'wpc_door_panels.jpg')]
      },
      { 
        name: 'WPC Window Panels', 
        desc: 'Durable WPC window panels with natural wood appearance', 
        icon: '🪟',
        images: [productPhoto('WPC', 'wpc_window_panel_new.jpg'),productPhoto('WPC', 'window_panels.JPG')]
      },
      { 
        name: 'WPC Door Frames', 
        desc: 'Durable WPC door frames with natural wood appearance', 
        icon: '🪟',
        images: [productPhoto('WPC', 'WPC DOOR FRAME.jpg'), productPhoto('WPC', 'door_frames_1.jpg')]
      },
      { 
        name: 'WPC Window Frames', 
        desc: 'Durable WPC window frames with natural wood appearance', 
        icon: '🪟',
        images: [productPhoto('WPC', 'wpc_window_frame_4.jpg'), productPhoto('WPC', 'wpc_window_frame_1.jpg'), productPhoto('WPC', 'wpc_window_frame_2.jpg'), productPhoto('WPC', 'wpc_window_frame_3.jpg')]
      },
    ]
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We will contact you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="App">
      {/* Image zoom lightbox */}
      {zoomLightbox && (
        <div 
          className="zoom-lightbox"
          onClick={() => setZoomLightbox(null)}
          role="dialog"
          aria-modal="true"
          aria-label="Zoomed image"
        >
          <button type="button" className="zoom-lightbox-close" onClick={() => setZoomLightbox(null)} aria-label="Close">×</button>
          <div className="zoom-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={zoomLightbox.images[zoomLightbox.currentIndex]} 
              alt="" 
              className="zoom-lightbox-image"
              onClick={(e) => e.stopPropagation()}
            />
            {zoomLightbox.images.length > 1 && (
              <>
                <button
                  type="button"
                  className="zoom-lightbox-prev"
                  onClick={(e) => { e.stopPropagation(); setZoomLightbox(z => ({ ...z, currentIndex: (z.currentIndex - 1 + z.images.length) % z.images.length })); }}
                  aria-label="Previous"
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="zoom-lightbox-next"
                  onClick={(e) => { e.stopPropagation(); setZoomLightbox(z => ({ ...z, currentIndex: (z.currentIndex + 1) % z.images.length })); }}
                  aria-label="Next"
                >
                  ›
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Floating actions: Back to Top + WhatsApp, center-aligned stack */}
      <div className="floating-actions">
        {showBackToTop && (
          <button
            type="button"
            className="back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Back to top"
          >
            ↑
          </button>
        )}
        <a
          href="https://wa.me/919721521791?text=Hi%2C%20I%20am%20interested%20in%20your%20products%20and%20want%20to%20know%20more%20about%20them"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
            className="whatsapp-icon"
          />
        </a>
      </div>

      {/* Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="navbar-logo-row">
            <a href="#home" className="logo-link">
              <img src={`${process.env.PUBLIC_URL || ''}/BC-Logo.jpg`} alt="Balaji Chaukhat" className="navbar-logo" />
            </a>
            <img src={`${process.env.PUBLIC_URL || ''}/25th-year-logo.gif`} alt="25 years - Building Masterpieces Since 1999" className="navbar-25th-logo" />
          </div>
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#products">Products</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        id="home"
        className="hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL || ''}/ampun%20suhu%206.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-inner">
          <div className="hero-left">
            <div className="hero-content">
              <h1 className="hero-title">Balaji Chaukhat - Premium RCC & WPC Products</h1>
              <p className="hero-subtitle">Saving Thousands of Trees Every Year - Eastern UP's Largest Manufacturer of Eco-Friendly Door & Window Frames Since 1999</p>
              <div className="hero-buttons">
                <button className="btn btn-primary" onClick={() => document.getElementById('contact').scrollIntoView({behavior: 'smooth'})}>Get Quote</button>
                <button className="btn btn-secondary" onClick={() => document.getElementById('products').scrollIntoView({behavior: 'smooth'})}>View Products</button>
                <a href={`${process.env.PUBLIC_URL || ''}/Balaji%20Chaukhat%20WPC%20Booklet.pdf`} download="Balaji-Chaukhat-WPC-Booklet.pdf" className="btn btn-brochure">Download Brochure</a>
              </div>
            </div>
            <div className="hero-slideshow">
              <div className="hero-slideshow-track">
                {heroSlideshowImages.map((src, i) => (
                  <div key={i} className={`hero-slideshow-slide ${i === heroSlide ? 'active' : ''}`}>
                    <img src={src} alt="" />
                  </div>
                ))}
              </div>
              <div className="hero-slideshow-dots">
                {heroSlideshowImages.map((_, i) => (
                  <button key={i} type="button" className={`hero-slideshow-dot ${i === heroSlide ? 'active' : ''}`} onClick={() => setHeroSlide(i)} aria-label={`Slide ${i + 1}`} />
                ))}
              </div>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <h3>20000+</h3>
                <p>Satisfied Customers</p>
              </div>
              <div className="stat">
                <h3>25+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat">
                <h3>200+</h3>
                <p>Dealers Network</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="products">
        <div className="container">
          <h2 className="section-title">Our Products</h2>
          <p className="section-subtitle">RCC & WPC Products - Sustainable alternatives to traditional wood</p>
          
          {!selectedCategory ? (
            // Category Selection View
            <>
              <div className="category-grid">
                {categories.map((category, idx) => (
                  <div 
                    key={idx} 
                    className="category-card"
                    onClick={() => setSelectedCategory(category.name)}
                  >
                    <div className="category-icon">{category.icon}</div>
                    <h3>{category.name}</h3>
                    <p>{category.desc}</p>
                    <button className="btn-link">View Products →</button>
                  </div>
                ))}
              </div>
            </>
          ) : (
            // Products View
            <>
              <button 
                className="back-button" 
                onClick={() => {
                  setSelectedCategory(null);
                  setActiveProduct(0);
                }}
              >
                ← Back to Categories
              </button>
              <h3 className="selected-category-title">{selectedCategory}</h3>
              
              {/* Category Overview */}
              <div className="category-overview">
                {selectedCategory === 'RCC Products' && (
                  <div className="overview-content-wrapper">
                    <div className="overview-text">
                      <h4>What is RCC?</h4>
                      <p>
                        RCC (Reinforced Cement Concrete) products are precast concrete items offering superior strength, durability, and resistance to water, termites, and fire. These eco-friendly alternatives to wood are manufactured under controlled conditions for consistent quality and dimensional accuracy.
                      </p>
                    </div>
                    <div className="comparison-table">
                      <table>
                        <thead>
                          <tr>
                            <th>Description</th>
                            <th>Wood</th>
                            <th>Iron</th>
                            <th>RCC</th>
                            <th>Benefits</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Cost</td>
                            <td>Very Expensive</td>
                            <td>Expensive</td>
                            <td className="highlight">Economical</td>
                            <td>30-40% Saving</td>
                          </tr>
                          <tr>
                            <td>Material</td>
                            <td>Wood</td>
                            <td>Iron</td>
                            <td className="highlight">Cement Concrete</td>
                            <td>More Stronger</td>
                          </tr>
                          <tr>
                            <td>Termite/corrosive</td>
                            <td>Not Resistant</td>
                            <td>Resistant</td>
                            <td className="highlight">Resistant</td>
                            <td>More Durable</td>
                          </tr>
                          <tr>
                            <td>Fire</td>
                            <td>Not Resistant</td>
                            <td>Resistant</td>
                            <td className="highlight">Resistant</td>
                            <td>Safety Benefits</td>
                          </tr>
                          <tr>
                            <td>Water</td>
                            <td>Shape Changes</td>
                            <td>Corrosive</td>
                            <td className="highlight">No Effect</td>
                            <td>Restores Beauty</td>
                          </tr>
                          <tr>
                            <td>Handling</td>
                            <td>Not Easy</td>
                            <td>Not Easy</td>
                            <td className="highlight">Easy</td>
                            <td>Speed up the work</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {selectedCategory === 'WPC Products' && (
                  <div className="overview-content-wrapper">
                    <div className="overview-text">
                      <h4>What is WPC?</h4>
                      <p>
                        WPC (Wood Plastic Composite) combines wood fibers with thermoplastic polymers, offering natural wood aesthetics with superior durability. These products are termite-proof, waterproof, weather-resistant, and don't warp or rot like natural wood.
                      </p>
                    </div>
                    <div className="comparison-table">
                      <table>
                        <thead>
                          <tr>
                            <th>Description</th>
                            <th>Wood Ply</th>
                            <th>WPC</th>
                            <th>Benefits</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Cost</td>
                            <td>Very Expensive</td>
                            <td className="highlight">Economical</td>
                            <td>30-40% Saving</td>
                          </tr>
                          <tr>
                            <td>Strength</td>
                            <td>Good</td>
                            <td className="highlight">Best</td>
                            <td>More Stronger</td>
                          </tr>
                          <tr>
                            <td>Screw Holding / Hinging</td>
                            <td>Good</td>
                            <td className="highlight">Best</td>
                            <td>More Stronger</td>
                          </tr>
                          <tr>
                            <td>Durability</td>
                            <td>Short</td>
                            <td className="highlight">Long (100 years)</td>
                            <td>Worthy investment</td>
                          </tr>
                          <tr>
                            <td>Termite/corrosive</td>
                            <td>Not Resistant</td>
                            <td className="highlight">Resistant</td>
                            <td>More Durable</td>
                          </tr>
                          <tr>
                            <td>Fire</td>
                            <td>Not Resistant</td>
                            <td className="highlight">Resistant</td>
                            <td>Safety Benefits</td>
                          </tr>
                          <tr>
                            <td>Water</td>
                            <td>Shape Changes</td>
                            <td className="highlight">No Effect</td>
                            <td>Size remains same</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>

              <div className="products-grid">
                {products[selectedCategory].map((product, idx) => {
                  const images = product.images || [];
                  const slideKey = `${selectedCategory}-${idx}`;
                  const currentSlide = (cardSlideIndex[slideKey] ?? 0) % Math.max(1, images.length);
                  const hasMultiple = images.length > 1;
                  return (
                    <div 
                      key={idx} 
                      className={`product-card ${activeProduct === idx ? 'active' : ''}`}
                      onMouseEnter={() => setActiveProduct(idx)}
                    >
                      <div 
                        className="product-card-image-wrap"
                        role="button"
                        tabIndex={0}
                        onClick={() => images.length > 0 && setZoomLightbox({ images, currentIndex: currentSlide })}
                        onKeyDown={(e) => e.key === 'Enter' && images.length > 0 && setZoomLightbox({ images, currentIndex: currentSlide })}
                        aria-label={`View ${product.name} image larger`}
                      >
                        {images.length > 0 && (
                          <img 
                            src={images[currentSlide]} 
                            alt={`${product.name} ${hasMultiple ? currentSlide + 1 : ''}`} 
                            className="product-card-image" 
                          />
                        )}
                        {hasMultiple && (
                          <>
                            <button
                              type="button"
                              className="product-card-slide-btn product-card-slide-prev"
                              onClick={(e) => { e.stopPropagation(); setCardSlideIndex(s => ({ ...s, [slideKey]: (currentSlide - 1 + images.length) % images.length })); }}
                              aria-label="Previous image"
                            >
                              ‹
                            </button>
                            <button
                              type="button"
                              className="product-card-slide-btn product-card-slide-next"
                              onClick={(e) => { e.stopPropagation(); setCardSlideIndex(s => ({ ...s, [slideKey]: (currentSlide + 1) % images.length })); }}
                              aria-label="Next image"
                            >
                              ›
                            </button>
                            <div className="product-card-dots">
                              {images.map((_, i) => (
                                <button
                                  key={i}
                                  type="button"
                                  className={`product-card-dot ${i === currentSlide ? 'active' : ''}`}
                                  onClick={(e) => { e.stopPropagation(); setCardSlideIndex(s => ({ ...s, [slideKey]: i })); }}
                                  aria-label={`Image ${i + 1}`}
                                />
                              ))}
                            </div>
                          </>
                        )}
                      </div>
                      <h3>{product.name}</h3>
                      <p>{product.desc}</p>
                      <button className="btn-link">Learn More →</button>
                    </div>
                  );
                })}
              </div>
              <button 
                className="back-button" 
                onClick={() => {
                  setSelectedCategory(null);
                  setActiveProduct(0);
                  document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                ← Back to Categories
              </button>
            </>
          )}
        </div>
      </section>

      {/* Features Section - grid order: row1 tops, row2 descs, row3 tops, ... so descriptions align across columns */}
      <section className="features">
        <div className="container">
          <h2 className="section-title-white">Features of RCC/WPC Products</h2>
          <div className="features-grid">
            <div className="feature-top"><div className="feature-icon">💧</div><h3>100% Waterproof</h3></div>
            <div className="feature-top"><div className="feature-icon">🐛</div><h3>Termite Proof</h3></div>
            <p className="feature-desc">Complete protection against water damage and moisture</p>
            <p className="feature-desc">No risk of termite infestation unlike traditional wood</p>
            <div className="feature-top"><div className="feature-icon">⭐</div><h3>Superior Quality & Durable</h3></div>
            <div className="feature-top"><div className="feature-icon">🔥</div><h3>Fire Resistant</h3></div>
            <p className="feature-desc">Long-lasting construction that stands the test of time</p>
            <p className="feature-desc">Enhanced safety with fire-resistant properties</p>
            <div className="feature-top"><div className="feature-icon">✨</div><h3>Smooth Finish</h3></div>
            <div className="feature-top"><div className="feature-icon">💰</div><h3>Economical</h3></div>
            <p className="feature-desc">Premium aesthetic finish ready for painting or polishing</p>
            <p className="feature-desc">Cost-effective solution compared to traditional alternatives</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <h2 className="section-title">About Balaji Chaukhat</h2>
          <div className="about-content">
            <div className="about-text">
              <p>Founded in 1999 by Balkrishna Tharad, an engineering professional, Balaji Chaukhat began with a vision: to provide sustainable alternatives to wooden frames that are becoming increasingly rare and expensive.</p>
              <p>After starting research & development in 1993, we established our manufacturing facility in Mau's Industrial Estate and pioneered door-window frames made from cast cement concrete (RCC). These eco-friendly frames quickly gained public support and trust.</p>
              <p><strong>Today, we are the largest manufacturer of Precast Cement Concrete products in Eastern UP,</strong> offering Door, Window & Ventilator Frames, Cement Beds, Park Benches, Desk Benches, Boundary Poles and Precast Boundary Walls.</p>
              <p>Following the success of our RCC products, we introduced <strong>"Balaji Palla"</strong> - a revolutionary WPC (Wood Plastic Composite) product line combining wood particles with thermoplastic resin, offering Door Panels, Window Panels, Frames, and furniture items.</p>
              <ul className="about-list">
                <li>✓ 200+ Dealer Network</li>
                <li>✓ 20000+ Satisfied Customers</li>
                <li>✓ Saving Thousands of Trees Annually</li>
                <li>✓ Eco-Friendly Manufacturing</li>
              </ul>
            </div>
            <div className="about-image">
              <div className="about-placeholder">🏭</div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section - grid order: row of tops, row of descs, so descriptions align across columns */}
      <section className="why-choose">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="why-grid">
            <div className="why-top"><div className="why-icon">😊</div><h3>Customer Satisfaction</h3></div>
            <div className="why-top"><div className="why-icon">🎯</div><h3>High Quality Products</h3></div>
            <p className="why-desc">We prioritize your needs and ensure complete satisfaction with every product</p>
            <p className="why-desc">Uncompromising quality standards in every product we manufacture</p>
            <div className="why-top"><div className="why-icon">🌱</div><h3>Environmental Friendly</h3></div>
            <div className="why-top"><div className="why-icon">💪</div><h3>Unparalleled Strength</h3></div>
            <p className="why-desc">Saving thousands of trees every year with sustainable alternatives</p>
            <p className="why-desc">Lasting for years and years with superior durability</p>
            <div className="why-top"><div className="why-icon">🏭</div><h3>25+ Years Experience</h3></div>
            <div className="why-top"><div className="why-icon">🤝</div><h3>200+ Dealer Network</h3></div>
            <p className="why-desc">Established in 1999, serving Eastern UP with excellence</p>
            <p className="why-desc">Wide distribution network ensuring easy availability</p>
          </div>
        </div>
      </section>

      {/* Founder Video Section */}
      <section className="founder-video">
        <div className="container">
          <h2 className="section-title">Glimpse of our company</h2>
          <p className="section-subtitle">Learn about our journey and vision from Balkrishna Tharad</p>
          <div className="video-container">
            <iframe 
              width="100%" 
              height="100%" 
              src="https://www.youtube.com/embed/tu_B7vZF-Tc?autoplay=1&mute=1&loop=1&playlist=tu_B7vZF-Tc&controls=1" 
              title="Balaji Chaukhat - Founder's Message" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">Ready to transform your space? Contact us today</p>
          <div className="contact-content">
            <form className="contact-form" onSubmit={handleSubmit}>
              <input 
                type="text" 
                placeholder="Your Name" 
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
              <input 
                type="email" 
                placeholder="Email Address" 
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
              />
              <input 
                type="tel" 
                placeholder="Phone Number" 
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                required
              />
              <textarea 
                placeholder="Your Message" 
                rows="4"
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                required
              ></textarea>
              <button type="submit" className="btn btn-primary">Send Message</button>
            </form>
            <div className="contact-info">
              <div className="info-item">
                <div className="info-icon">📍</div>
                <div>
                  <h4>Location</h4>
                  <p>Mau's Industrial Estate, Eastern UP</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p>+91-9721521791</p>
                  <p>+91-9721521797</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">✉️</div>
                <div>
                  <h4>Email</h4>
                  <p>balajichaukhat@gmail.com</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">🏪</div>
                <div>
                  <h4>Dealer Network</h4>
                  <p>200+ dealers across Eastern UP</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 Balaji Chaukhat. All rights reserved.</p>
          <div className="social-links">
            <a href="#facebook">Facebook</a>
            <a href="#instagram">Instagram</a>
            <a href="#linkedin">LinkedIn</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
